<div *ngIf="outcomeStatus" class="height-100per">
  <div class="flex-display height-100per">
    <div class="float-L width-77">
      <div class="left-scrollbar" id="searchPage">
        <div class="pl-5per pr-0">
          <div class="pcform pr-1rem ">
            <div class="">
              <span class="searchtext flex-display">
                <span class="flex-display">
                  Showing&nbsp;
                  <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem" *ngIf="!isFullyLoaded"></mat-spinner>
                  <span *ngIf="isFullyLoaded" class="">{{numberOfResult}}&nbsp;</span>
                  results in {{category}} categories for
                </span>
              </span>
             

              <div class="flex-display">
                <div class="width-80 content-blue">
                  <div class="search-container">
                    <input type="text" class="searchTopic search-top-heading" id="searchInput" value="{{elasticSearchCondition.Searchterm}}" (input)="handleInputChange()" (focus)="changeBool()" (keyup.enter)="sendSearch()" />
                    <span class="clear-search" (click)="whenCross()"></span>
                  </div>
                </div>
                <button mat-button class="btn-cancel" [class.active]="isButtonActive" (click)="sendSearch()" >New Search</button>
              </div>
              <div class="display_block">
                <span class="search-bread-crumb" *ngIf="elasticSearchCondition.Area.length > 0  && paragraph">in {{elasticSearchCondition.Area.join(', ')}} areas</span>
                <span class="search-bread-crumb" *ngIf="(elasticSearchCondition.TopicId.length > 0) && paragraph">, for Topic {{elasticSearchCondition.TopicId.join(', ')}}</span>
                <span class="search-bread-crumb" *ngIf="elasticSearchTopicCondition.Area.length > 0  && topics">in {{elasticSearchTopicCondition.Area.join(', ')}} areas</span>
                <span class="search-bread-crumb" *ngIf="selectedOtherContentType.length > 0  && other">in {{selectedOtherContentType.join(', ')}}</span>
                <span class="search-bread-crumb" *ngIf="(selectedPdfFilter.length > 0 || elasticSearchCondition.OtherSourceDocType.length > 0)  && otherSource">
                  in {{elasticSearchCondition.OtherSourceDocType.join(', ')}}
                  <span *ngIf="(selectedPdfFilter.length > 0 && elasticSearchCondition.OtherSourceDocType.length > 0)">,</span>
                  {{selectedPdfFilter.join(', ')}}
                </span>

              </div>
            </div>
            <div>
              <div class="glossaryTab  move-down">
                <button class="tablinks active" id="myButton" (click)="searchContent($event, 'paragraph')" (keyup.enter)="searchContent($event, 'paragraph')" tabindex="0">
                  <span class="bold">
                    {{sectionHeader}}&nbsp;
                    <span class="font-12 bold" id="paragraphCount">({{totalParagraphResultCount}})</span>
                  </span>
                </button>
                <button class="tablinks" (click)="searchContent($event, 'topics')" (keyup.enter)="searchContent($event, 'topics')" tabindex="0">
                  <span class="bold flex-display">
                    {{topicsHeader}}&nbsp;
                    <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem" *ngIf="!isFullyLoaded"></mat-spinner>
                    <span *ngIf="isFullyLoaded" id="topicsCount" class="lightGrey-color font-12 bold">({{totalTopicResultCount}})</span>
                  </span>
                </button>
                <button class="tablinks" (click)="searchContent($event, 'others')" (keyup.enter)="searchContent($event, 'others')" tabindex="0">
                  <span class="bold flex-display">
                    {{glossaryToolsHeader}}&nbsp;
                    <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem" *ngIf="!isFullyLoaded"></mat-spinner>
                    <span *ngIf="isFullyLoaded" id="othersCount" class="lightGrey-color font-12 bold">({{totalOtherCount}})</span>
                  </span>
                </button>
                <button class="tablinks" (click)="searchContent($event, 'othersource')" (keyup.enter)="searchContent($event, 'othersource')" tabindex="0">
                  <span class="bold flex-display">
                    {{otherSourceHeader}}&nbsp;
                    <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem" *ngIf="!isFullyLoaded"></mat-spinner>
                    <span *ngIf="isFullyLoaded" id="othersourceCount" class="lightGrey-color font-12 bold">({{totalOtherSourceCount}})</span>
                  </span>
                </button>
              </div>
              <div>
                <div class="searchContent" *ngIf="paragraph && !topics && !other && !otherSource">
                  <div id="scrollList">
                    <div class="searchResults" *ngFor="let paraRecord of paragraphSearchResult">
                      <div *ngIf="paraRecord.source.area != null && paraRecord.source.topicId != null && paraRecord.source.topicTitle != null && paraRecord.source.subtopicId != null && paraRecord.source.subtopicTitle != null">
                        <div class="pb-1rem">
                          <div class="flex-display width-100 justify-content-space-between">
                            <div class="flex-display float-L width-86 flex-wrap">
                              <span *ngIf="paraRecord.source.area != null" class="searchPartext white-space-pre color-nav" [innerHTML]="paraRecord.source.area | highlightSearchTerm: elasticSearchCondition.Searchterm">&nbsp;</span>
                              <img _ngcontent-uoe-c167="" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                              <span *ngIf="paraRecord.source.topicId != null && paraRecord.source.topicTitle != null" class="searchPartext white-space-pre color-nav">{{paraRecord.source.topicId}}&nbsp;</span>
                              <span class="searchPartext white-space-pre color-nav" [innerHTML]="paraRecord.source.topicTitle | highlightSearchTerm: elasticSearchCondition.Searchterm"></span>&nbsp;
                              <img _ngcontent-uoe-c167="" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                              <span *ngIf="paraRecord.source.subtopicId != null && paraRecord.source.subtopicTitle != null" class="searchPartext white-space-pre color-nav">{{paraRecord.source.subtopicId}}&nbsp;</span>
                              <span class="searchPartext white-space-pre color-nav" [innerHTML]="paraRecord.source.subtopicTitle | highlightSearchTerm: elasticSearchCondition.Searchterm">&nbsp;</span>
                              <img src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right" class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow">
                            </div>
                            <div class="flex-display float-R width-9">
                              <div *ngIf="paraRecord.source.topicId != null" class="searchPartext color-nav itcBookFont">{{paraRecord.source.topicId}}-</div>
                              <div *ngIf="paraRecord.source.subtopicId != null" class="searchPartext color-nav itcBookFont">{{paraRecord.source.subtopicId}}-</div>
                              <div *ngIf="paraRecord.source.sectionId != null && paraRecord.source.paragraphId == null" class="searchPartext color-nav itcBookFont">{{paraRecord.source.sectionId}}-</div>
                              <div *ngIf="paraRecord.source.paragraphId != null" class="searchPartext color-nav itcBookFont">{{paraRecord.source.paragraphId}}</div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="paraRecord.source.sectionTitle != null" class="mr_0_5rem"><a class="searchPartext pdf-link font-20 color-heading itcBookFont" href="{{paraRecord.source.url}}" id="{{paraRecord.source.url}}/{{paraRecord.source.topicId}}-{{paraRecord.source.subtopicId}}-{{paraRecord.source.paragraphId}}" attr.data-message="searchNavigation" attr.data-isSearchLink="true" (click)="openLinkById($event)" [innerHTML]="paraRecord.source.sectionTitle | highlightSearchTerm: elasticSearchCondition.Searchterm"></a></div>
                        <div class="ml-2 mt_1" [innerHTML]="paraRecord.source.body | highlightSearchTerm: elasticSearchCondition.Searchterm"></div>
                      </div>
                    </div>
                    <div *ngIf="paragraphSearchResult.length==0">
                      <div class="pb-16 itcBookFont font-24 pendingheading">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                    </div>
                  </div>
                  <div [ngClass]="totalParagraphResultCount> paragraphResultCount?'align-item-single-line':''">
                    <div class="mt-2 width-65">
                      <button mat-button class="load-more-btn pb-1" *ngIf="(totalParagraphResultCount> paragraphResultCount)" (click)="loadNextPage('paragraphTab')" (keyup.enter)="loadNextPage('paragraphTab')" tabindex="0">{{result_loadmore}}</button>
                    </div>
                    <div class="links cursor-pointer flex-display pl-12rem float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop && totalParagraphResultCount.length!=0" (keyup.enter)="setFocus()" tabindex="0">
                      <span class="pr-0-5rem mt-2 width-5-5rem font-14">Back to Top</span>
                      <span>
                        <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement search_arrow_icon mt-1-5rem" alt="right up">
                      </span>
                    </div>
                  </div>
                </div>
                <div class="searchContent" *ngIf="topics && !other && !paragraph  && !otherSource">
                  <div *ngIf="isFullyLoaded; else topics_spinner">
                    <div id="scrollList">
                      <div class="searchTopicResults" *ngFor="let topicRecord of topicSearchResult">
                        <div class="pb-1rem" *ngIf="topicRecord.source.area != null && topicRecord.source.topicId != null && topicRecord.source.topicTitle != null">
                          <div class="flex-display">
                            <div class="flex-display float-L">
                              <div (click)="getSubtopicResults(topicRecord.source)" *ngIf="(topicRecord.source.topicId != null || topicRecord.source.topicId != '') && (topicRecord.source.topicTitle != null || topicRecord.source.topicTitle != '')" class="searchTopicText pdf-link mr_0_5rem">
                                {{topicRecord.source.topicId}}
                                <span *ngIf="(topicRecord.source.topicId != null || topicRecord.source.topicId != '') && (topicRecord.source.topicTitle != null || topicRecord.source.topicTitle != '')">&nbsp;</span>
                                <span *ngIf="(topicRecord.source.topicTitle != null || topicRecord.source.topicTitle != '')" class="right-Overlay" [innerHTML]="topicRecord.source.topicTitle | highlightSearchTerm: elasticSearchCondition.Searchterm" tabindex="0"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="topicSearchResult.length==0 && isFullyLoaded">
                        <div class="pb-16 itcBookFont font-24 pendingheading">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                      </div>
                    </div>
                    <div [ngClass]="totalTopicResultCount> topicResultCount?'align-item-single-line':''">
                      <div class="mt-2 width-65">
                        <button mat-button class="load-more-btn pb-1" [ngClass]="!enableBackToTop?'left-40per':''" *ngIf="totalTopicResultCount> topicResultCount" (click)="loadNextPage('topicsTab')" (keyup.enter)="loadNextPage('topicsTab')" tabindex="0">{{result_loadmore}}</button>
                      </div>
                      <div class="links cursor-pointer flex-display pl-12rem float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop && totalTopicResultCount.length!=0" (keyup.enter)="setFocus()" tabindex="0">
                        <span class="pr-0-5rem mt-2 width-5-5rem font-14">Back to Top</span>
                        <span>
                          <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement search_arrow_icon mt-1-5rem" alt="right up">
                        </span>
                      </div>
                    </div>
                  </div>
                  <ng-template #topics_spinner>
                    <div class="spinner_center_align">
                      <mat-spinner strokeWidth="3" [diameter]="40" class="mr-0-5rem"></mat-spinner>
                    </div>
                  </ng-template>
                </div>
                <div class="searchContent" *ngIf="other && !paragraph && !topics  && !otherSource">
                  <div *ngIf="isFullyLoaded; else other_spinner">
                    <div class="searchResults" id="scrollList">
                      <div class="mt-40" *ngFor="let result of annotationResult">
                        <div class="flex-display">
                          <div>
                            <img src="../../../assets/icons/pencil-alt.svg" class="history-type-images" alt="Annotation">
                          </div>
                          <div>&nbsp;&nbsp;</div>
                          <div>
                            <span class="font-18 highlight-blue border-bottom-help cursor-pointer" (click)="redirectToAnnotationUrl(result)" (keyup.enter)="redirectToAnnotationUrl(result)" tabindex="0" [innerHTML]="result.annotationTitle | highlightSearchTerm: elasticSearchCondition.Searchterm"></span><br />
                            <p class="history-breadcrumb mt-8px">{{result.createdOn.split(" ")[0] | date:'longDate'}}</p>
                            <span class="mat-Info mt-8px" [innerHTML]="result.annotationDescription | highlightSearchTerm : elasticSearchCondition.Searchterm"></span>
                          </div>
                        </div>
                      </div>

                      <div class="mt-40" *ngFor="let result of bookmarkResult">
                        <div class="flex-display">
                          <div>
                            <img src="../../../assets/icons/Bookmark.svg" class="history-type-images" alt="Bookmark">
                          </div>
                          <div>&nbsp;&nbsp;</div>
                          <div>
                            <span class="font-18 itcBookFont" [innerHTML]="result.bookmarkTitle | highlightSearchTerm : elasticSearchCondition.Searchterm"></span><br />
                            <div class="flex-display history-breadcrumb">
                              <div *ngFor="let breadcrumbParts of result.bookMarkBreadCrumb.toString().split('~')">
                                <div *ngIf="breadcrumbParts != result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-1]" class="flex-display font-14">
                                  {{breadcrumbParts}}
                                  <span *ngIf="breadcrumbParts != result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-2]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right"></span>
                                  <span *ngIf="breadcrumbParts == result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-2]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right"></span>
                                </div>
                              </div>
                            </div>
                            <div class="flex-display mt-4px">
                              <span class="font-18 highlight-blue border-bottom-help cursor-pointer" (click)="redirectToBookmarkUrl(result)" (keyup.enter)="redirectToBookmarkUrl(result)" tabindex="0">
                                {{result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-1]}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mt-40" *ngFor="let contact of contacts">
                        <div class="flex-display">
                          <div>
                            <img src="../../../assets/icons/OpenBook-black.svg" class="history-type-images" alt="History">
                          </div>
                          <div>&nbsp;&nbsp;</div>
                          <div>
                            <span class="font-18 searchGlossaryHeader" [innerHTML]="contact.name"></span><br />
                            <div class="ml-32px mt-1rem">
                              <span *ngIf="contact.type=='sec'" class="text-transform-capitalize">{{secDefinition}}</span>
                              <span *ngIf="contact.type=='sec'" class="mr_0_5rem ml-0-5">|</span>
                              <span *ngIf="contact.topic.length > 0" class="glossaryTermUsage right-Overlay mr_0_5rem pdf-link" id="glossary-term-usage" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
                              <span *ngIf="contact.topic.length > 0">
                                <span>|</span>&nbsp;&nbsp;<span class="topic">{{seeTopics}}</span>
                                <span *ngFor="let topic of contact.seetopic; let i = index">
                                  &nbsp;
                                  <span class="topicNum right-Overlay mr_0_5rem pdf-link" id="glossary-term-topic" [topicData]="topic.topicData" appHostListenerClick>{{topic.topic}}</span>
                                  <span *ngIf="i != (contact.seetopic.length -1)">,</span>
                                </span>
                              </span>
                              <span class="text-transform-uppercase bold topic font-black" *ngIf=" contact.seetopic.length == 0">
                                No Incoming Links
                              </span>
                            </div>
                            <p *ngIf="contact.seetopic.length == 0" class="ml-32px"></p>
                            <p class="mat-Info ml-32px" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" (click)="OpenLink($event)" [innerHTML]="contact.capital"></p>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="otherCount==0">
                        <div class="pb-16 itcBookFont font-24 pendingheading">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                      </div>
                    </div>
                    <div [ngClass]=" totalOtherCount>otherCount?'align-item-single-line':''">
                      <div class="mt-2 width-65">
                        <button mat-button class="load-more-btn pb-1" [ngClass]="!enableBackToTop?'left-40per':''" *ngIf="(totalOtherCount>otherCount)" (click)="loadNextPage('othersTab')" (keyup.enter)="loadNextPage('othersTab')" tabindex="0">{{result_loadmore}}</button>
                      </div>
                      <div class="links cursor-pointer flex-display pl-12rem float-R text-decoration-none" (click)="setFocus()" (keyup.enter)="setFocus()" tabindex="0" *ngIf="enableBackToTop && otherCount.length!=0">
                        <span class="pr-0-5rem mt-2 width-5-5rem font-14">Back to Top</span>
                        <span>
                          <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement search_arrow_icon mt-1-5rem" alt="right up">
                        </span>
                      </div>
                    </div>
                  </div>
                  <ng-template #other_spinner>
                    <div class="spinner_center_align">
                      <mat-spinner strokeWidth="3" [diameter]="40" class="mr-0-5rem"></mat-spinner>
                    </div>
                  </ng-template>
                </div>
                <div class="searchContent" *ngIf="otherSource && !topics && !other && !paragraph">
                  <div *ngIf="isFullyLoaded; else otherSource_spinner">
                    <div id="scrollList">
                      <div class="searchResults" *ngFor="let paraRecord of otherSourceSearchResult">
                        <div *ngIf="paraRecord.source.title != null">
                          <div *ngIf="paraRecord.source.title != null && paraRecord.source.url.includes('.pdf')" class="searchOtherSourceext pdf-link mr_0_5rem font-20 color-heading ptb-1-25"><span class="searchOtherSource_pdf-link" (click)="openLinkById($event)" id={{paraRecord.source.url}} [innerHTML]="paraRecord.source.title | highlightSearchTerm: elasticSearchCondition.Searchterm"></span></div>
                          <div *ngIf="paraRecord.source.title != null  && !paraRecord.source.url.includes('.pdf')" class="mr_0_5rem"><a class="searchOtherSourceext pdf-link font-20 color-heading" href="{{paraRecord.source.url}}" (click)="openLinkById($event)" id={{paraRecord.source.url}} [innerHTML]="paraRecord.source.title | highlightSearchTerm: elasticSearchCondition.Searchterm"></a></div>
                          <div class="ml-2 mt_1" [innerHTML]="paraRecord.source.body | highlightSearchTerm: elasticSearchCondition.Searchterm"></div>
                        </div>
                      </div>
                      <div>
                        <div class="searchPdfResults" *ngFor="let pdfRecord of pdfSearchResult">
                          <div *ngIf="pdfRecord.source.attachment.title != null">
                            <div *ngIf="pdfRecord.source.attachment.title != null" class="searchOtherSourceext pdf-link mr_0_5rem font-20 color-heading ptb-1-25">
                              <span class="searchOtherSource_pdf-link" (click)="openSitesPdf($event,pdfRecord.source.url)" id={{pdfRecord.source.url}} [innerHTML]="pdfRecord.source.attachment.title | highlightSearchTerm: elasticSearchCondition.Searchterm"></span>
                            </div>
                            <div class="ml-2 mt_1" [innerHTML]="pdfRecord.source.attachment.content | highlightSearchTerm: elasticSearchCondition.Searchterm"></div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="otherSourceSearchResult.length==0 && pdfSearchResultCount==0 && isFullyLoaded">
                        <div class="pb-16 itcBookFont font-24 pendingheading">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                      </div>

                    </div>
                    <div [ngClass]=" totalOtherSourceCount> otherSourceCount?'align-item-single-line':''">
                      <div class="mt-2 width-65">
                        <button mat-button class="load-more-btn pb-1" [ngClass]="!enableBackToTop?'left-40per':''" *ngIf="(totalOtherSourceCount> otherSourceCount)" (click)="loadNextPage('otherSourceTab')" (keyup.enter)="loadNextPage('otherSourceTab')" tabindex="0">{{result_loadmore}}</button>
                      </div>
                      <div class="links cursor-pointer flex-display pl-12rem float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop && totalOtherSourceCount!=0" (keyup.enter)="setFocus()" tabindex="0">
                        <span class="pr-0-5rem mt-2 width-4-5rem font-14">Back to Top</span>
                        <span>
                          <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement search_arrow_icon mt-1-5rem" alt="right up">
                        </span>
                      </div>
                    </div>
                  </div>
                  <ng-template #otherSource_spinner>
                    <div class="spinner_center_align">
                      <mat-spinner strokeWidth="3" [diameter]="40" class="mr-0-5rem"></mat-spinner>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="searchrightfloat float-R scrollbar">

      <div class="padding-rightOverlay">
        <div *ngIf="other && !paragraph && !topics && !otherSource">
          <div *ngIf="(glossaryResultCount > 0 && (annotationCount > 0 || bookmarkCount > 0))">
            <div class="answer content-blue width-100 bold right-overlay-heading"> {{contentType}}</div>
            <div>
              <mat-checkbox color="primary" class="pt-10 right-overlay-menu" *ngIf="glossaryResultCount > 0" [disabled]="isFilterLocked" [checked]="GlossaryChecked" [value]="Glossary" (change)="checkedOtherContentType($event)">{{Glossary}}</mat-checkbox>
            </div>
            <div>
              <mat-checkbox color="primary" class="pt-10 right-overlay-menu" *ngIf="annotationCount > 0" [disabled]="isFilterLocked" [checked]="AnnotationChecked" [value]="MyAnnotations" (change)="checkedOtherContentType($event)">{{MyAnnotations}}</mat-checkbox>
            </div>
            <div>
              <mat-checkbox color="primary" class="pt-10 right-overlay-menu" *ngIf="bookmarkCount > 0" [disabled]="isFilterLocked" [checked]="BookmarkChecked" [value]="MyBookmarks" (change)="checkedOtherContentType($event)">{{MyBookmarks}}</mat-checkbox>
            </div>
          </div>
        </div>
        <div *ngIf="otherAreaResult.length > 0 && other && ShowOtherAreaFilter">

          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{narrowResults}}</div>

          <div class="pl-8px" *ngFor="let Otherarea of otherAreaResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="Otherarea.checked" [value]="Otherarea.key"
                          (change)="checkedOtherArea($event)">{{Otherarea.key}}&nbsp;({{Otherarea.docCount}})</mat-checkbox>
          </div>
        </div>
        <div *ngIf="paragraphAreaResult.length > 0 && (paragraph)">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{filterSort}}</div>

          <div class="pl-8px">
            <mat-radio-button id="radio_hitBased" color="primary" class="pt-10 right-overlay-menu contact-support-radio-button" value="HitBased" [checked]="radioHitBased"
                              (change)="onFilterOrderChange('hitBased')" tabindex="0">
              {{filterSortByNumber}}
            </mat-radio-button>
            <mat-radio-button id="radio_leftNav" color="primary" class="pt-10 right-overlay-menu contact-support-radio-button" value="leftNav" [checked]="radioleftNav"
                              (change)="onFilterOrderChange('leftNav')" tabindex="0">
              {{filterSortByLeftNav}}
            </mat-radio-button>
          </div>

          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{narrowResults}}</div>

          <div class="pl-8px" *ngFor="let paraArea of paragraphAreaResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="paraArea.checked" [value]="paraArea.key" (change)="checkedParaArea($event)">{{paraArea.key}}&nbsp;({{paraArea.docCount}})</mat-checkbox>
          </div>
        </div>

        <div *ngIf="topicAreaResult.length > 0 && (topics)">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{filterSort}}</div>

          <div class="pl-8px">
            <mat-radio-button id="radio_hitBased" color="primary" class="pt-10 right-overlay-menu contact-support-radio-button" value="HitBased" [checked]="radioHitBased"
                              (change)="onFilterOrderChange('hitBased')" tabindex="0">
              {{filterSortByNumber}}
            </mat-radio-button>
            <mat-radio-button id="radio_leftNav" color="primary" class="pt-10 right-overlay-menu contact-support-radio-button" value="leftNav" [checked]="radioleftNav"
                              (change)="onFilterOrderChange('leftNav')" tabindex="0">
              {{filterSortByLeftNav}}
            </mat-radio-button>
          </div>

          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{narrowResults}}</div>

          <div class="pl-8px" *ngFor="let topicArea of topicAreaResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="topicArea.checked" [value]="topicArea.key" (change)="checkedTopicArea($event)">{{topicArea.key}}&nbsp;({{topicArea.docCount}})</mat-checkbox>
          </div>
        </div>

        <div *ngIf="(OtherSourceAreaResult.length>0 || pdfSearchResultCount>0) && otherSource">
          <!--<div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{filterSort}}</div>

          <div class="pl-8px">
            <mat-radio-button id="radio_hitBased" color="primary" class="pt-10 right-overlay-menu contact-support-radio-button" value="HitBased" [checked]="radioHitBased"
                              (change)="onFilterOrderChange('hitBased')" tabindex="0">
              {{filterSortByNumber}}
            </mat-radio-button>
            <mat-radio-button id="radio_leftNav" color="primary" class="pt-10 right-overlay-menu contact-support-radio-button" value="leftNav" [checked]="radioleftNav"
                              (change)="onFilterOrderChange('leftNav')" tabindex="0">
              {{filterSortByLeftNav}}
            </mat-radio-button>
          </div>-->

          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{narrowResults}}</div>

          <div class="pl-8px" *ngFor="let OtherSourcearea of OtherSourceAreaResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu text-transform-capitalize" [disabled]="isFilterLocked" [checked]="OtherSourcearea.checked" [value]="OtherSourcearea.key" (change)="checkedOtherSourceArea($event)">{{OtherSourcearea.key}}&nbsp;({{OtherSourcearea.docCount}})</mat-checkbox>
          </div>
          <div *ngIf="pdfSearchFilterResults.length>0">
            <div class="pl-8px" *ngFor="let pdfsource of pdfSearchFilterResults">
              <mat-checkbox color="primary" class="pt-10 right-overlay-menu text-transform-capitalize" [disabled]="isFilterLocked" [checked]="pdfsource.checked" [value]="pdfsource.key" (change)="checkedpdfFilter($event)">{{pdfsource.key}}&nbsp;({{pdfsource.docCount}})</mat-checkbox>
            </div>
          </div>
        </div>

        <div *ngIf="elasticSearchCondition.Area.length > 0 && !topics && !other && !otherSource && paragraphAreaResult.length > 0 && topicResult.length>0">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{NarrowTopic}}</div>

          <div class="pl-8px" *ngFor="let topic of topicResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="topic.checked" [value]="topic.key" (change)="checkedTopic($event)">{{topic.key}}&nbsp;({{topic.docCount}})</mat-checkbox>
          </div>
        </div>


        <div *ngIf="paragraphContentTypeResult.length > 0 && !other && !otherSource && !topics">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{resultRelatedTo}}</div>
          <div class="pl-8px" *ngFor="let paraType of paragraphContentTypeResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="paraType.checked" [value]="paraType.key" (change)="checkedParagraphContentType($event)">{{paraType.key}}&nbsp;({{paraType.docCount}})</mat-checkbox>
          </div>
        </div>

        <div *ngIf="topicContentTypeResult.length > 0 && !other && !otherSource && !paragraph">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{resultRelatedTo}}</div>
          <div class="pl-8px" *ngFor="let topicType of topicContentTypeResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="topicType.checked" [value]="topicType.key" (change)="checkedTopicContentType($event)">{{topicType.key}}&nbsp;({{topicType.docCount}})</mat-checkbox>
          </div>
        </div>

        <div *ngIf="role == 'Professional'">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{result_recentsearchterm}}</div>
          <div *ngFor="let term of recentSearchTerm" class="mt-8px"><span class="font-14 highlight-blue border-bottom-help cursor-pointer" (click)="searchNewTerm(term.searchKeyword)" (keyup.enter)="searchNewTerm(term.searchKeyword)" tabindex="0">{{term.searchKeyword}}</span> </div>
        </div>
      </div>
    </div>

  </div>
</div>

